import HTTP from '../HTTPApiGeo';

const BASE_URL = 'https://geo.api.gouv.fr/departements';
const params = {
  fields: 'nom,code',
  format: 'json',
};

export async function browseDepartements() {
  // eslint-disable-next-line no-useless-catch
  try {
    const query = Object.assign(params);
    const response = await HTTP.get(BASE_URL, { params: query });
    return response;
  } catch (e) {
    throw e;
  }
}

export function nothing() {
}
